export {default} from './Main';



// WEBPACK FOOTER //
// ./src/components/Layout/Main/index.ts